import { render, staticRenderFns } from "./BasePostCodeInputAction.vue?vue&type=template&id=3b31b1eb&scoped=true&"
import script from "./BasePostCodeInputAction.vue?vue&type=script&lang=ts&"
export * from "./BasePostCodeInputAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b31b1eb",
  null
  
)

export default component.exports